// First rows of the AdMongrel ad inventory sheet, so the panel has something
// to show before a full import. "Restore sample data" brings these back.

const AXIOM = {
  partner: "Axiom",
  territories: ["UK"],
  cpm: 23.5,
  currency: "EUR",
  reach: 30000000,
  formats: ["CTV"],
  adFormats: ["video"],
  adTypes: ["midroll"],
  platform: "Virgin",
  revshare: "",
  contactName: "Colin Ramsay",
  contactEmail: "cramsay@axiommedia.co",
};

const CHANNELS = [
  ["Inside Channel", ["food", "home", "garden"]],
  ["Homes Under the Hammer", ["house & garden"]],
  ["Inside Crime", ["true crime"]],
  ["Mystery TV", ["crime"]],
  ["Deal Masters", ["haggling", "entrepreneurship"]],
  ["History Hunters", ["history", "documentaries"]],
  ["Real Wild", ["nature", "wildlife", "outdoors"]],
  ["Baywatch", ["Baywatch"]],
  ["Red Bull TV", ["action sports"]],
  ["Wonder", ["science", "technology", "engineering"]],
  ["Real Crime", ["true crime"]],
  ["History", ["history", "documentaries"]],
  ["Chat", ["interviews", "talks"]],
  ["WDo Movies", ["movies"]],
];

export function seedChannels() {
  return CHANNELS.map(([channelName, genres], i) => ({
    ...AXIOM,
    id: `seed-${i + 1}`,
    channelName,
    genres,
  }));
}
